import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import renderRichText from '../../utils/renderRichText';
import '../../pages/page-styles.scss';
import './styles.scss';

const SchoolsComponent = () => {
  const data = useStaticQuery(graphql`
    {
      schools: contentfulFacilitators(
        title: { eq: "Schools Enrolled in iDECIDE" }
      ) {
        title
        content {
          raw
        }
        mapLink
      }
    }
  `);

  const { schools } = data;
  const schoolTitle = schools.title;
  const schoolContent = JSON.parse(schools.content.raw);

  return (
    <div className="content">
      <div id="Schools Enrolled in iDECIDE" className="anchor">
        <section className="section has-background-info">
          <div className="container">
            <div>
              <h3 className="is-size-3">{schoolTitle}</h3>
              <div className="columns">
                <div className="column is-8">
                  {renderRichText(schoolContent)}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section has-background-info">
          <div className="has-text-centered">
            <iframe
              title="Schools offering iDECIDE"
              src={schools.mapLink}
              width="90%"
              height="480"
            ></iframe>
          </div>
          <p className="is-size-6 has-text-centered is-italic">
            Inclusion on the map does not designate level of implementation.
            Please ask our team for more information
          </p>
        </section>
      </div>
    </div>
  );
};

export default SchoolsComponent;
